import {mdiEmailSend} from '@mdi/js';
import AppConfig from '../../../modules/AppConfig';
import {KGFB} from '../../../modules/Const';
import App from '../../../components/OvbApp.vue';
import VueApp from '../../../modules/VueApp';
import tarifa from '../modules/KgfbStore';
import navigation from '../../../modules/navigation';

import '../../../components/GFBAjanlatAsyncComponentLoader';
import '../../../components/CASCOAjanlatAsyncComponentLoader';
import '../../../components/GFBKedvezmenyekAsyncComponentLoader';
import {ovbColors} from '../../../config/ovbtheme';

const routes = [
    {
        path: '/',
        redirect: '/Alapadatok',
    },
    {
        path: '/Alapadatok/:id?/:tid?',
        component: () => import('../../../components/gfb/ovb/views/alapadatok/Alapadatok.vue'),
        saveUrl: '/saveTarifa',
    },
    {
        path: '/Dijak/:id?/:tid?',
        component: () => import('../../../components/gfb/ovb/views/dijak/Dijak.vue'),
        saveUrl: '/saveDijtabla',
    },
    {
        path: '/AjanlatAdatok/:id?/:tid?',
        component: () => import('../../../components/gfb/ovb/views/ajanlatiadatok/AjanlatiAdatok.vue'),
        saveUrl: '/saveAjanlat',
    },
    {
        path: '/Nyilatkozatok/:id?/:tid?',
        component: () => import('../../../components/gfb/ovb/views/nyilatkozatok/Nyilatkozatok.vue'),
        saveUrl: '/saveNyilatkozat',
    },
    {
        path: '/Ajanlat/:id?/:tid?',
        component: () => import('../../../components/gfb/shared/views/ajanlat/Ajanlat.vue'),
        saveUrl: '/save',
    },
];

const pages = [
    {
        title: 'Alapadatok',
        route: '/Alapadatok',
    },
    {
        title: 'Díjak',
        route: '/Dijak',
    },
    {
        title: 'Ajánlati adatok',
        route: '/AjanlatAdatok',
    },
    {
        title: 'Nyilatkozatok',
        route: '/Nyilatkozatok',
    },
    {
        title: 'Ajánlat',
        route: '/Ajanlat',
    },
];

const sideBarNavItems = [
    [
        {
            id: 'modozat-scroll-to',
            label: 'Kötni kívánt módozat',
        },
        {
            id: 'kotesok-scroll-to',
            label: 'Szerződés kötés oka',
        },
        {
            id: 'beleponyil-scroll-to',
            label: 'Belépési nyilatkozat',
        },
        {
            id: 'tarifa-adatok-scroll-to',
            label: 'Tarifa adatok',
        },
        {
            id: 'gepjarmu-adatok-scroll-to',
            label: 'Gépjármű adatok',
        },
        {
            id: 'uzembentarto-scroll-to',
            label: 'Üzembentartó adatok',
        },
        {
            id: 'karok-scroll-to',
            label: 'Okozott károk',
        },
    ],
    [],
    [
        {
            id: 'kotesok-scroll-to',
            label: 'Biztosítói adatok',
        },
        {
            id: 'beleponyil-scroll-to',
            label: 'Ügyfél adatok',
        },
    ],
];
navigation.saveIcon = mdiEmailSend;

const appConfig = new AppConfig();
appConfig.setHelp({
    title: null,
    message: null,
    codename: 'kgfb',
    aktiv: true,
});
appConfig.setModozat(KGFB);
appConfig.setWindowOptions({
    loadingWindow: true,
    notifications: true,
    tarifaAdatok: false,
    hibajelentes: true,
    breadCrumb: true,
});
appConfig.setPages(pages);
appConfig.setTheme(ovbColors, { outline: false });
appConfig.setSideBarNavItems(sideBarNavItems);
appConfig.setOnline(true);
const cfg = appConfig.getConfig();

const query = new URLSearchParams(window.location.search);
if (localStorage && query.has('hash')) {
    localStorage.setItem('ovb-user-hash', query.get('hash'));
}

/* eslint-disable-next-line no-new */
new VueApp(routes, tarifa, App, cfg);
